const ErrorDisplay = ({error} : {error?: Error}) => {
    console.error(error)
    alert(`
        Wystąpił nieoczekiwany błąd. Prosimy spróbować ponownie za chwilę.
        W przypadku długotrwałych problemów prosimy o kontakt pod adresem sekretariat@opanuj.to
    `)
	return null
}
export default ErrorDisplay;